import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { AiOutlineQuestionCircle } from "react-icons/ai";

const AlertDialog = ({
  open,
  handleClose,
  handleDelete,
  title = "Bạn có muốn xóa ý kiến này?",
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll={"paper"}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      className="doc-popup"
      fullWidth
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100vw",
            maxWidth: "90vw", // Set your width here
            mx: 0,
          },
        },
      }}
    >
      <DialogTitle
        id="scroll-dialog-title"
        className="text-2xl text-[#23374D] !pt-8 min-h-[112px]"
        sx={{
          // minHeight: 600,
          maxHeight: 500,
        }}
      >
        <AiOutlineQuestionCircle
          style={{ color: "red", width: "20px", height: "20px" }}
        />
        <span
          style={{
            fontFamily: "roboto",
            fontWeight: 600,
            fontSize: "16px",
            lineHeight: 1.5,
          }}
        >
          {title}
        </span>
      </DialogTitle>{" "}
      <DialogActions sx={{ marginRight: "20px", paddingBottom: "20px" }}>
        <Button
          sx={{
            color: "rgba(0,0,0,0.88)",
            border: "1px solid #d9d9d9",
            borderRadius: "5px",
            textTransform: "none",
            fontFamily: "roboto",
            fontWeight: 400,
          }}
          onClick={handleClose}
        >
          Không
        </Button>
        <Button
          sx={{
            color: "#ff4d4f",
            border: "1px solid #ff4d4f",
            borderRadius: "5px",
            textTransform: "none",
            fontFamily: "roboto",
            fontWeight: 400,
          }}
          onClick={handleDelete}
          autoFocus
        >
          Đồng ý
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
